import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLocation } from "react-router";

import { FaArrowLeftLong } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa";
import HubblePageContainer from "./components/HubblePageContainer";
import UploadsArbirtionElement from "./components/UploadsArbitrantionElement";
import HuubleCard from "./components/HuubleCard";
import CustomTextArea from "../../assets/components/CustomTextArea";
import { Checkbox, FormControlLabel } from "@mui/material";
// import JudgingSlider from "./components/JudgingSlider";
import HubbleButton from "./components/HubbleButton";
import errorHandler from "../../assets/utils/ErrorHandler";
import {
  getMyUpload,
  getRefereeByFormId,
  refereeForm,
  updateReferee,
} from "../../assets/services/apiServices";
import Loading from "../../assets/containers/loadingDialog";
import toast from "react-hot-toast";

const Judge = () => {
  const navigate = useNavigate();
  // const [sliderValues, setSliderValues] = useState([0, 0, 0, 0, 0, 0]);
  const [allowed, setAllowed] = useState(false);

  const [comment, setComment] = useState("");
  const [forData, setForData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refereeId, setRefereeId] = useState(null);
  const [loadingGetReferee, setLoadingGetReferee] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const { id } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    getFormData();
  }, [id]);

  // const handleSliderChange = (index, newValue) => {
  //   const updatedValues = [...sliderValues];
  //   updatedValues[index] = newValue;
  //   setSliderValues(updatedValues);
  // };

  const getFormData = async () => {
    try {
      const response = await getMyUpload(id);
      setForData(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err);
    }
  };

  useEffect(() => {
    if (pathname.includes("edit")) {
      getReferee();
    }
  }, [pathname]);

  const getReferee = async () => {
    setLoadingGetReferee(true);
    try {
      const response = await getRefereeByFormId(id);
      console.log(response.data);
      setComment(response.data.hubbleFormReferee.comment);
      const res = response.data.hubbleFormReferee;
      setRefereeId(res._id);
      setAllowed(res.allowedToProceedToNextLevel)
      // setSliderValues([
      //   res.scoreQualityOfPerformance,
      //   res.scoreCreativity,
      //   res.scoreAttractiveness,
      //   res.scoreMessage,
      //   res.scoreOriginality,
      //   res.scoreOther,
      // ]);
      setLoadingGetReferee(false);
    } catch (err) {
      setLoadingGetReferee(false);
      errorHandler(err);
    }
  };

  const judgeForm = async () => {
    setLoadingSubmit(true);
    try {
      await refereeForm({
        hubbleForm: id,
        comment: comment,
        allowedToProceedToNextLevel: allowed,
        // scoreQualityOfPerformance: sliderValues[0],
        // scoreCreativity: sliderValues[1],
        // scoreAttractiveness: sliderValues[2],
        // scoreMessage: sliderValues[3],
        // scoreOriginality: sliderValues[4],
        // scoreOther: sliderValues[5],
      });
      toast.success("با موفقیت ثبت شد.");
      setLoadingSubmit(false);
      navigate(-1, { replace: true });
    } catch (err) {
      setLoadingSubmit(false);
      errorHandler(err);
    }
  };

  const updateForm = async () => {
    setLoadingSubmit(true);
    try {
      await updateReferee(refereeId, {
        comment: comment,
        allowedToProceedToNextLevel: allowed,
        // scoreQualityOfPerformance: sliderValues[0],
        // scoreCreativity: sliderValues[1],
        // scoreAttractiveness: sliderValues[2],
        // scoreMessage: sliderValues[3],
        // scoreOriginality: sliderValues[4],
        // scoreOther: sliderValues[5],
      });
      toast.success("با موفقیت به روز رسانی شد.");
      setLoadingSubmit(false);
      navigate(-1, { replace: true });
    } catch (err) {
      setLoadingSubmit(false);
      errorHandler(err);
    }
  };

  // const totalScore =
  //   sliderValues[0] +
  //   sliderValues[1] +
  //   sliderValues[2] +
  //   sliderValues[3] +
  //   sliderValues[4] +
  //   sliderValues[5];

  return (
    <HubblePageContainer>
      <div className="d-flex justify-content-between align-items-center py-2">
        <h4>داوری</h4>
        <div onClick={() => navigate(-1)}>
          <FaArrowLeftLong size={20} />
        </div>
      </div>
      <div className="mt-4">
        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <Loading />
          </div>
        ) : (
          <UploadsArbirtionElement present={true} data={forData} />
        )}
        {loadingGetReferee ? (
          <div className="d-flex justify-content-center my-5">
            <Loading />
          </div>
        ) : (
          <HuubleCard>
            {/* <JudgingSlider
              title="کیفیت و قدرت اجرا (شرکت کننده ایده خود را چقدر باکیفیت، قدرتمند و مسلط اجرا نموده است؟)"
              value={sliderValues[0]}
              onChange={(val) => handleSliderChange(0, val)}
            />
            <br />
            <JudgingSlider
              title="بداعت و خلاقیت (اثر ارسال شده چقدر خلاقانه و جدید است؟)"
              max={15}
              value={sliderValues[1]}
              onChange={(val) => handleSliderChange(1, val)}
            />
            <br />
            <JudgingSlider
              title="جذابیت و برانگیزانندگی (اثر ارسالی برای بقیه چقدر می تواند جذاب باشد؟)"
              max={15}
              value={sliderValues[2]}
              onChange={(val) => handleSliderChange(2, val)}
            />
            <JudgingSlider
              title=" پیام‌مندی و درونمایه‌ی اثر(اثر ارسال شده حامل چه پیامی می باشد؟)"
              max={15}
              value={sliderValues[3]}
              onChange={(val) => handleSliderChange(3, val)}
            />
            <JudgingSlider
              title="اصالت و هویت کار اثر ارسال شده چقدر اصیل و با هویت است؟) "
              max={10}
              value={sliderValues[4]}
              onChange={(val) => handleSliderChange(4, val)}
            />
            <JudgingSlider
              title=" تیمی بودن (ناظر به مجریان) داستان‌مندی/ تعاملی بودن (با تماشاچیان)/ و.."
              max={5}
              value={sliderValues[5]}
              onChange={(val) => handleSliderChange(5, val)}
            />

            <p className="my-4">مجموع امتیاز : {totalScore}</p> */}
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allowed}
                    onChange={(e) => setAllowed(e.target.checked)}
                    icon={
                      <div
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: 8,
                          backgroundColor: "#ccc",
                        }}
                      />
                    }
                    checkedIcon={
                      <div
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: 8,
                          backgroundColor: "#F2AD17",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaCheck color="#fff" size={14} />
                      </div>
                    }
                    sx={{
                      "&.Mui-checked": {
                        color: "#F2AD17",
                      },
                    }}
                  />
                }
                label={"مجاز به شرکت در مرحله بعد"}
                labelPlacement="end"
                sx={{marginRight:0}}
              />
            </div>

            <CustomTextArea
              dark={true}
              label={"نظرداور"}
              placeholder={"توضیحات"}
              value={comment}
              handleChange={(val) => setComment(val)}
            />
            <div className="my-4">
              {loadingSubmit ? (
                <div className="d-flex justify-content-center ">
                  <Loading />
                </div>
              ) : pathname.includes("edit") ? (
                <HubbleButton onClick={updateForm}>به روزرسانی</HubbleButton>
              ) : (
                <HubbleButton onClick={judgeForm}>ثبت</HubbleButton>
              )}
            </div>
          </HuubleCard>
        )}
      </div>
    </HubblePageContainer>
  );
};

export default Judge;
